import React from 'react';
import styled from 'styled-components';
import { TacticIcon } from 'assets/icon/icon';

export interface TacticCounterProps {
  count: number;
  className?: string;
  'data-cy'?: string;
}

const TacticCountContainer = styled.div`
  display: flex;
  align-items: center;
  margin-top: 4px;
  color: #656565;
  font-size: 14px;
`;

const TacticCount = styled.span`
  margin-left: 6px;
  font-weight: 500;
`;

const TacticCounter: React.FC<TacticCounterProps> = ({
  count,
  className,
  'data-cy': dataCy,
}) => {
  if (count <= 0) {
    return null;
  }

  const tacticText = count === 1 ? 'tactic' : 'tactics';

  return (
    <TacticCountContainer className={className} data-cy={dataCy}>
      <TacticIcon size={16} />
      <TacticCount>
        {count} {tacticText}
      </TacticCount>
    </TacticCountContainer>
  );
};

export default TacticCounter;
